import { DragNDropList } from 'components/DragNDropList';
import { VideoCard } from 'components/VideoCard';
import { getImageURL } from 'utils/tableListFormat';
import { LocalizationProvider, TimeField } from '@mui/x-date-pickers';
import { Box, Typography } from '@mui/material';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { parseISO } from 'date-fns';

const formatVideoToForm = value => {
  if (!value) return;

  return {
    video: {
      videoId: value?.id || value?.video?.videoId,
    },
    sortNumber: value.sortNumber,
    version: value.version,
    nextSuggestionTimeSeconds: value.nextSuggestionTimeSeconds,
    status: value?.id || value?.video?.status,
  };
};

export const DragNDropListOrderCollections = ({
  id,
  videoToCollection,
  setVideoToCollection,
  viewFields,
  setValue,
  getValues,
}) => {
  const deleteItem = itemId => {
    const updatedVideoToCollection = videoToCollection.filter(
      item => item.id !== itemId
    );

    const items = getValues('videos');
    const updateItems = items.filter(item => item.video.videoId !== itemId);

    setValue('videos', []);
    setValue(
      'videos',
      updateItems.map((i, index) =>
        formatVideoToForm({
          ...i,
          sortNumber: index + 1,
          nextSuggestionTimeSeconds: i.nextSuggestionTimeSeconds,
        })
      )
    );

    setVideoToCollection(updatedVideoToCollection);
  };

  const editItem = (itemId, time) => {
    const updateItemStatus = itemId => {
      setVideoToCollection(prevState =>
        prevState.map(item => {
          if (item.id === itemId) {
            return {
              ...item,
              statusEdit: !item.statusEdit, // toggle status
            };
          }
          return item;
        })
      );
    };

    updateItemStatus(itemId);
  };

  const updateTime = (time, id) => {
    if (time && !isNaN(time.getTime())) {
      const hour = time.getHours();
      const minutes = time.getMinutes();
      const seconds = time.getSeconds();
      const totalSeconds = hour * 3600 + minutes * 60 + seconds;

      const updateItemTime = itemId => {
        setVideoToCollection(prevState =>
          prevState.map(item => {
            if (item.id === itemId) {
              return {
                ...item,
                nextSuggestionTimeSeconds: totalSeconds, // toggle status
              };
            }
            return item;
          })
        );
      };

      updateItemTime(id);

      // setValue(
      //   'videos',
      //   getValues('videos').map((i, index) => {
      //     if (index === values.index) {
      //       return formatVideoToForm({
      //         ...i,
      //         sortNumber: index + 1,
      //         nextSuggestionTimeSeconds: totalSeconds <= 60 ? 60 : totalSeconds,
      //       });
      //     } else {
      //       return formatVideoToForm({
      //         ...i,
      //         sortNumber: index + 1,
      //         nextSuggestionTimeSeconds:
      //           i.nextSuggestionTimeSeconds <= 60
      //             ? 60
      //             : i.nextSuggestionTimeSeconds,
      //       });
      //     }
      //   })
      // );
    }
  };

  const secondsToTime = totalSeconds => {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;

    return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
  };

  // const formattedTime = secondsToTime(nextSuggestionTimeSeconds);

  return (
    <DragNDropList
      id={id}
      onChange={value => {
        setVideoToCollection(value.map(i => i.data));
      }}
      items={videoToCollection.map((i, index) => {
        const formattedTime = secondsToTime(i.nextSuggestionTimeSeconds);

        return {
          id: i.id,
          data: i,
          component: (
            <VideoCard.Root
              key={i.id || i.contentId}
              sx={{ flex: 1, border: '1px solid blue' }}>
              <VideoCard.Image
                variant="square"
                image={getImageURL(i)}
                size="small">
                <VideoCard.CornerAdornment name={'film'} />
              </VideoCard.Image>
              <Box>
                <VideoCard.DescriptionDetail {...i} />
                <Typography
                  variant="body2"
                  lineHeight="20px"
                  marginLeft="24px"
                  fontSize="12px"
                  color="#6F6B7D">
                  {`Limite de Players: ${
                    i?.viewsLimit === 0 ? 'Ilimitado' : i?.viewsLimit
                  }`}
                </Typography>
                <Typography
                  variant="body2"
                  lineHeight="20px"
                  fontSize="12px"
                  marginLeft="24px"
                  color="#6F6B7D">
                  Visualizações: {i?.totalViews}
                </Typography>
              </Box>
              <VideoCard.ActionsContainer>
                <Box>
                  <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <TimeField
                      disabled={!i.statusEdit}
                      style={{
                        fontWeight: 500,
                        width: 74,
                        marginRight: '8px',
                        color: 'rgba(111, 107, 125, 1)',
                      }}
                      size="small"
                      variant="standard"
                      fullWidth
                      focused
                      name={'suggestionTimeSeconds'}
                      // onChange={time => updateTime({ time, id })}
                      onChange={time => updateTime(time, i.id)}
                      format="HH:mm:ss"
                      value={parseISO(`1970-01-01T${formattedTime}`)} // Parse the formatted time string
                    />
                  </LocalizationProvider>
                </Box>
                {!i.statusEdit && (
                  <VideoCard.ActionButton
                    action="edit"
                    data-no-dnd="true"
                    disabled={viewFields}
                    onClick={() => {
                      editItem(i.id, formattedTime);
                    }}
                  />
                )}
                {i.statusEdit && (
                  <VideoCard.ActionButton
                    action="save"
                    data-no-dnd="true"
                    disabled={viewFields}
                    onClick={() => {
                      editItem(i.id, formattedTime);
                    }}
                  />
                )}
                <VideoCard.ActionButton action="move" disabled={viewFields} />
                <VideoCard.ActionButton
                  action="delete"
                  disabled={viewFields}
                  data-no-dnd="true"
                  onClick={() => {
                    deleteItem(i.id);
                  }}
                />
              </VideoCard.ActionsContainer>
            </VideoCard.Root>
          ),
        };
      })}
    />
  );
};


